import { microserviceClientProcessAPI, microserviceClientProcessAPIWithoutAuth, microServiceClientProcessRevokeAPI } from "./microserviceClientProcessAPI";
import { decryptGCM, decryptStorage } from "utils/utils";
import { AesGCMTagEncrypted } from "../../config/config.json";

export const clientProcess = {
    withAuth: microserviceClientProcessAPI.injectEndpoints({
        endpoints: (builder) => ({
            updateStatus: builder.mutation({
                query: (data) => ({
                    url: `/ECD/UpdateStatus`,
                    method: "POST",
                    body: data,
                }),
                extraOptions: { maxRetries: 0 },
            }),
            reasonRejected: builder.query({
                query: () => ({
                    url: `/Consult/getRevocationReason`,
                    method: "GET",
                }),
                extraOptions: { maxRetries: 0 },
            }),
            revocationCertificate: builder.mutation({
                query: (data) => ({
                    url: `/ECD/revokeCertificate`,
                    method: "POST",
                    body: data
                }),
                extraOptions: { maxRetries: 0 },
            }),
            getValidations: builder.query({
                query: (data) => ({
                    url: `/Consult/getValidations`,
                    method: "GET",
                    headers: {
                        "externalRequestId": data.externalRequestId
                    },
                }),
                extraOptions: { maxRetries: 0 },
            }),
            getValidationExec: builder.mutation({
                query: (data) => ({
                    url: `/Consult/getValidations`,
                    method: "GET",
                    headers: {
                        "externalRequestId": data.externalRequestId
                    },
                }),
                extraOptions: { maxRetries: 0 },
            }),
            updateRequestData: builder.mutation({
                query: (data) => ({
                    url: `/Consult/updateRequestData`,
                    method: "POST",
                    body: data
                }),
                extraOptions: { maxRetries: 0 },
            }),
            getReasons: builder.query({
                query: () => ({
                    url: `/Consult/getRejectReason`,
                    method: "GET",
                }),
                transformResponse: (response) => {
                    if (response.status === 200 && response.data && response.data.status === false) {
                        return { ...response, isError: true, isSuccess: false };
                    }
                    return response;
                },
                extraOptions: { maxRetries: 0 },
                keepUnusedDataFor: 0,
            }),
            validatorVerification: builder.mutation({
                query: (data) => ({
                    url: `/ECD/ValidatorVerification`,
                    method: "POST",
                    body: data
                }),
                transformResponse: (response) => {
                    if (response.status === 200 && response.data && response.data.status === false) {
                        return { ...response, isError: true, isSuccess: false };
                    }
                    return response;
                },
                extraOptions: { maxRetries: 0 },
                keepUnusedDataFor: 0,
            }),
            getRejectedReasons: builder.query({
                query: (data) => ({
                    url: `/Consult/getRejectReason`,
                    method: "GET",
                    headers: {
                        "apply": data.apply
                    },
                }),
                transformResponse: (response) => {
                    if (response.status === 200 && response.data && response.data.status === false) {
                        return { ...response, isError: true, isSuccess: false };
                    }
                    return response;
                },
                extraOptions: { maxRetries: 0 },
            }),
            rejectRequest: builder.mutation({
                query: (data) => ({
                    url: `/ECD/RejectRequest`,
                    method: "POST",
                    body: data
                }),
                transformResponse: (response) => {
                    if (response.status === false) {
                        return { ...response, isError: true, isSuccess: false };
                    }
                    return response;
                },
                transformErrorResponse: (error) => {
                    if (!error?.data?.statusDescription) {
                        error.data.statusDescription = "Ha ocurrido un error";
                    }
                    return error;
                },
                extraOptions: { maxRetries: 0 },
            }),
            getcertificate: builder.mutation({
                query: (data) => ({
                    url: `/Consult/downloadCertificate`,
                    method: "GET",
                    headers: {
                        "externalRequestId": data.externalRequestId
                    },
                }),
                extraOptions: { maxRetries: 0 },
            }),
            getElectronics: builder.query({
                query: (data) => ({
                    url: `/electronicCertificate/getCertificateList`,
                    method: "GET",
                    headers: {
                        emailOrPhone: data.emailOrPhone,
                        status: data.status,
                        lastStatusStartDate: data.lastStatusStartDate,
                        lastStatusEndDate: data.lastStatusEndDate,
                    }
                }),
                extraOptions: { maxRetries: 0 },
            }),
            getStatusElectronics: builder.query({
                query: () => ({
                    url: `/electronicCertificate/getStatusList`,
                    method: "GET",
                }),
                extraOptions: { maxRetries: 0 },
            }),
            getCertificateElectronicData: builder.query({
                query: (data) => ({
                    url: `/electronicCertificate/getCertificateData`,
                    method: "GET",
                    headers: {
                        crId: data.crId
                    }
                }),
                extraOptions: { maxRetries: 0 },
            }),
            getCertificateElectronicHistory: builder.query({
                query: (data) => ({
                    url: `/electronicCertificate/getCertificateHistory`,
                    method: "GET",
                    headers: {
                        crId: data.crId
                    }
                }),
                extraOptions: { maxRetries: 0 },
            }),
            registerCertificateRequest: builder.mutation({
                query: ({ data, headers }) => {
                    const requestOptions = {
                        url: `/ECD/registerCertificateRequest`,
                        method: "POST",
                        body: data
                    };
                    //Opcion de agregar headers actualmente para registro de solicitud de licenciamiento
                    if (headers) {
                        requestOptions.headers = headers;
                    }

                    return requestOptions;
                },
                extraOptions: { maxRetries: 0 },
            }),
            getSystemConfigurations: builder.query({
                query: (data) => ({
                    url: `/getsystemconfigurationfilter`,
                    method: "GET",
                    headers: { filter: data.filter }
                }),
                extraOptions: { maxRetries: 0 },
                keepUnusedDataFor: 0,
            }),
            getSystemConfiguration: builder.mutation({
                query: (data) => ({
                    url: `/getsystemconfiguration`,
                    method: "POST",
                    body: data
                }),
                extraOptions: { maxRetries: 0 },
            }),
            updateSystemConfiguration: builder.mutation({
                query: (data) => ({
                    url: `/ECD/updateSystemConfiguration`,
                    method: "PUT",
                    body: data
                }),
                extraOptions: { maxRetries: 0 },
            }),
            sendingManagementNotificationForPE: builder.mutation({
                query: (data) => ({
                    url: `/ECD/GestionNotificationMail`,
                    method: "POST",
                    body: data
                }),
                extraOptions: { maxRetries: 0 },
            }),
            registerIssuanceCredentials: builder.mutation({
                query: (data) => ({
                    url: `/ECD/issueCredentialsManagement`,
                    method: "POST",
                    body: data
                }),
                extraOptions: { maxRetries: 0 },
            }),
            getTokenCertificates: builder.query({
                query: (data) => ({
                    url: `/Consult/getDeliveryLogistics`,
                    method: "GET",
                    headers: data
                }),
                transformResponse: (response) => {
                    return response.status ? response?.data : [];
                },
                keepUnusedDataFor: 0,
                extraOptions: { maxRetries: 0 },
            }),
            registerFlexInfo: builder.mutation({
                query: (data) => ({
                    url: `/DeliveryLogistics/registerFlexInfo`,
                    method: "POST",
                    body: data
                }),
                transformResponse: (response) => {
                    return response?.data;
                },
                extraOptions: { maxRetries: 0 },
            }),
            getChannelProduct: builder.query({
                query: (data) => ({
                    url: `/Consult/getChannelProduct`,
                    method: "GET",
                    headers: data
                }),
                keepUnusedDataFor: 0,
                extraOptions: { maxRetries: 0 },
            }),
            massiveServientregaGuide: builder.mutation({
                query: (data) => ({
                    url: `/DeliveryLogistics/massiveServientregaGuide`,
                    method: "POST",
                    body: data
                }),
                extraOptions: { maxRetries: 0 },
                keepUnusedDataFor: 0
            }),
            generateServientregaManifiest: builder.mutation({
                query: (data) => ({
                    url: `/DeliveryLogistics/generateServientregaManifiest`,
                    method: "POST",
                    body: data
                }),
                extraOptions: { maxRetries: 0 },
            }),
            cancelServientregaGuide: builder.mutation({
                query: (data) => ({
                    url: `/DeliveryLogistics/cancelServientregaGuide`,
                    method: "POST",
                    body: data
                }),
                extraOptions: { maxRetries: 0 },
            }),
            generateServientregaGuide: builder.mutation({
                query: (data) => ({
                    url: `/DeliveryLogistics/generateServientregaGuide`,
                    method: "POST",
                    body: data
                }),
                extraOptions: { maxRetries: 0 },
                keepUnusedDataFor: 0,
            }),
            getDeliveryMethod: builder.query({
                query: (data) => ({
                    url: `/Consult/getDeliveryMethod`,
                    method: "GET",
                    headers: data
                }),
                keepUnusedDataFor: 0,
                extraOptions: { maxRetries: 0 },
            }),
            consultFile: builder.mutation({
                query: (data) => ({
                    url: `/Consult/consultFile`,
                    method: "GET",
                    headers: data
                }),
                keepUnusedDataFor: 0,
                extraOptions: { maxRetries: 0 },
            }),
            generateGuide: builder.mutation({
                query: (data) => ({
                    url: `/DeliveryLogistics/generateGuide`,
                    method: "POST",
                    body: data
                }),
                extraOptions: { maxRetries: 0 },
                keepUnusedDataFor: 0,
            }),
            confirmDelivery: builder.mutation({
                query: (data) => ({
                    url: `/DeliveryLogistics/confirmDelivery`,
                    method: "POST",
                    body: data
                }),
                extraOptions: { maxRetries: 0 },
                keepUnusedDataFor: 0,
            }),
            consultStatusRequestBySerialNumber: builder.query({
                query: (data) => ({
                    url: `/Consult/consultStatusRequestBySerialNumber`,
                    method: "GET",
                    headers: data
                }),
                keepUnusedDataFor: 0,
                extraOptions: { maxRetries: 0 },
            }),
            changeEMCStatus: builder.mutation({
                query: (data) => ({
                    url: `/ECD/changeEMCStatus`,
                    method: "POST",
                    body: data
                }),
                extraOptions: { maxRetries: 0 },
                keepUnusedDataFor: 0,
            }),
            ecdissuecertificate: builder.mutation({
                query: (data) => {
                    return {
                        url: `/ECD/ecdissuecertificate`,
                        method: "POST",
                        headers: {
                            "securityToken": data.securityToken
                        },
                        body: {
                            "contractRequestId": data.contractRequestId,
                            "official": data.official,
                        }
                    };
                },
                extraOptions: { maxRetries: 0 },
                keepUnusedDataFor: 0,
            }),
            getprocessreference: builder.query({
                query: (data) => ({
                    url: `/Consult/getprocessreference`,
                    method: "POST",
                    body: data
                }),
                keepUnusedDataFor: 0,
                extraOptions: { maxRetries: 0 },
                transformResponse: (response) => {
                    const tag = decryptStorage(AesGCMTagEncrypted)
                    return response?.data ? decryptGCM(response.data, tag) : [];
                },
            }),
            updateDeliveryLocation: builder.mutation({
                query: (data) => ({
                    url: `/DeliveryLogistics/updateDeliveryLocation`,
                    method: "POST",
                    body: data
                }),
                extraOptions: { maxRetries: 0 },
                keepUnusedDataFor: 0,
            }),
            requeueGuideServientrega: builder.mutation({
                query: (data) => ({
                    url: `/DeliveryLogistics/requeueGuideServientrega`,
                    method: "POST",
                    body: data
                }),
                extraOptions: { maxRetries: 0 },
                keepUnusedDataFor: 0,
            }),
            registerVIMStatus: builder.mutation({
                query: (data) => ({
                    url: `/ECD/registerVIMStatus`,
                    method: "POST",
                    body: data
                }),
                extraOptions: { maxRetries: 0 },
                keepUnusedDataFor: 0,
            }),
            consultServientregaControl: builder.query({
                query: (data) => ({
                    url: `/Consult/consultServientregaControl`,
                    method: "GET",
                    headers: {
                        "reference": data.reference,
                        "status": data.status,
                        "initDate": data.initDate,
                        "finishDate": data.finishDate
                      }
                }),
                extraOptions: { maxRetries: 0 },
                keepUnusedDataFor: 0,
                transformResponse: (response) => {
                    return response?.data?.result ? response?.data.result : [];
                },
            }),
            consultServientregaControlStatus: builder.query({
                query: () => ({
                    url: `/Consult/getServientregaControlStatus`,
                    method: "GET",
                }),
                extraOptions: { maxRetries: 0 },
                keepUnusedDataFor: 0,
                transformResponse: (response) => {
                    return response?.data ? response?.data : [];
                },
            }),
            associateSupervisor : builder.mutation({
                query: (data) => ({
                    url: `/ECD/associateSupervisor`,
                    method: "POST",
                    body: data.body,
                    headers : data.headers
                }),
                extraOptions: { maxRetries: 0 },
                keepUnusedDataFor: 0,
            }),
            getApplications: builder.query({
                query: () => ({
                    url: `/Consult/getApplications`,
                    method: "GET",
                }),
                extraOptions: { maxRetries: 0 },
                keepUnusedDataFor: 0,
                transformResponse: (response) => {
                    return response?.data ? response?.data : [];
                },
            }),
            getStepResult: builder.query({
                query: (data) => ({
                    url: `/Consult/getstepsresult`,
                    method: "GET",
                    headers: { "contractRequestId": data.crId }
                }),
                extraOptions: { maxRetries: 0 },
                keepUnusedDataFor: 0,
                transformResponse: (response) => {
                    return response.data ? response.data : [];
                },
            }),
            getRequestByContract: builder.query({
                query: (data) => ({
                    url: `/Consult/getRequestByContract`,
                    method: "GET",
                    headers: {
                        "contractId": data.contractId,
                        "status": data.status,
                        "subscriber": data.subscriber,
                        "reference": data.reference
                    }
                }),
                extraOptions: { maxRetries: 0 },
                keepUnusedDataFor: 0,
                transformResponse: (response) => {
                    return response?.data ? response?.data : [];
                },
            }),
        })
    }),
    withoutAuth: microserviceClientProcessAPIWithoutAuth.injectEndpoints({
        endpoints: (builder) => ({
            ecdFinalizeCertificate: builder.mutation({
                query: (data) => ({
                    url: `/ECD/finalizecertificate`,
                    method: "POST",
                    body: data,
                }),

                extraOptions: { maxRetries: 0 },
            })
        })
    }),
    withRevokeToken: microServiceClientProcessRevokeAPI.injectEndpoints({
        endpoints: (builder) => ({
            reasonRejectedRevoke: builder.query({
                query: () => ({
                    url: `/Consult/getRevocationReason`,
                    method: "GET",
                }),
                extraOptions: { maxRetries: 0 },
            }),
            revocationCertificateGSE: builder.mutation({
                query: (data) => ({
                    url: `/ECD/revokeCertificate`,
                    method: "POST",
                    body: data
                }),
                extraOptions: { maxRetries: 0 },
            }),
        })
    }),
};

export const {
    useUpdateStatusMutation,
    useReasonRejectedQuery,
    useRevocationCertificateMutation,
    useGetValidationsQuery,
    useGetValidationExecMutation,
    useUpdateRequestDataMutation,
    useGetReasonsQuery,
    useValidatorVerificationMutation,
    useGetRejectedReasonsQuery,
    useRejectRequestMutation,
    useGetcertificateMutation,
    useLazyGetElectronicsQuery,
    useGetStatusElectronicsQuery,
    useGetCertificateElectronicDataQuery,
    useGetCertificateElectronicHistoryQuery,
    useRegisterCertificateRequestMutation,
    useGetSystemConfigurationsQuery,
    useGetSystemConfigurationMutation,
    useUpdateSystemConfigurationMutation,
    useSendingManagementNotificationForPEMutation,
    useRegisterIssuanceCredentialsMutation,
    useGetTokenCertificatesQuery,
    useRegisterFlexInfoMutation,
    useGetChannelProductQuery,
    useMassiveServientregaGuideMutation,
    useGenerateServientregaManifiestMutation,
    useCancelServientregaGuideMutation,
    useGenerateServientregaGuideMutation,
    useLazyGetDeliveryMethodQuery,
    useGenerateGuideMutation,
    useConsultFileMutation,
    useConfirmDeliveryMutation,
    useLazyConsultStatusRequestBySerialNumberQuery,
    useChangeEMCStatusMutation,
    useEcdissuecertificateMutation,
    useGetprocessreferenceQuery,
    useUpdateDeliveryLocationMutation,
    useRequeueGuideServientregaMutation,
    useRegisterVIMStatusMutation,
    useConsultServientregaControlQuery,
    useConsultServientregaControlStatusQuery,
    useAssociateSupervisorMutation,
    useGetApplicationsQuery,
    useGetStepResultQuery,
    useGetRequestByContractQuery,
} = clientProcess.withAuth;
export const {
    useReasonRejectedRevokeQuery, useRevocationCertificateGSEMutation
} = clientProcess.withRevokeToken;
export const {
    useEcdFinalizeCertificateMutation
} = clientProcess.withoutAuth;
